<template>
  <v-row>
    <v-col
      cols="12"
    >
      <v-alert
        v-show="copyAlert"
        type="info"
        text
      >
        {{ msgClaveCopiado }}
      </v-alert>
      <alerta-firma-modal
        :show="showAlertModal"
        :firma="selectedFirma"
        @close="closeAlertModal"
        @updated="handleAlertUpdated"
      />
      <base-card>
        <v-card-text>
          <v-card-title>
            Lista de Firmas Electrónicas
          </v-card-title>
          <v-alert
            v-model="showInfoAlert"
            type="info"
            dismissible
            text
            dense
            class="mb-4"
          >
            <strong>Tip:</strong> Haz clic en el icono de alerta
            <v-icon small color="info" style="vertical-align: middle;">mdi-bell-outline</v-icon>
            para configurar notificaciones via correo electrónico de vencimiento de firma electrónica
          </v-alert>
          <v-row class="mb-4">
            <v-col
              v-if="!isGeneralAdmin"
              cols="12"
              sm="4"
            >
              <v-select
                v-model="selectedCompany"
                :items="filteredClients"
                item-text="text"
                item-value="IdCompania"
                label="Selecciona una compañía"
                prepend-inner-icon="mdi-sitemap"
                clearable
                @change="filtrarFirmas"
              >
                <template v-slot:prepend-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-text-field
                          v-model="searchCompany"
                          placeholder="Buscar"
                          prepend-inner-icon="mdi-magnify"
                          hide-details
                          dense
                        />
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </v-col>
            <v-spacer />
            <v-col
              cols="12"
              sm="4"
            >
              <v-text-field
                v-model="searchTable"
                append-icon="mdi-magnify"
                label="Buscar en tabla"
                single-line
                hide-details
              />
            </v-col>
          </v-row>
          <v-row
            v-if="loadingFirmas"
            class="fill-height"
            align-content="center"
            justify="center"
          >
            <v-col cols="6">
              <v-col
                class="text-subtitle-1 text-center"
                cols="12"
              >
                Cargando Firmas Electrónicas
              </v-col>
              <v-progress-linear
                color="red darken-4"
                indeterminate
                rounded
                height="6"
              />
            </v-col>
          </v-row>
          <v-data-table
            v-else
            :headers="headers"
            :items="listFirmas"
            :search="searchTable"
            class="elevation-1"
          >
            <template v-slot:[`item.active`]="{ item }">
              <v-icon
                v-if="item.active === 1"
                color="success darken-2"
                right
                class="mr-2"
              >
                mdi-account-check
              </v-icon>
              <v-icon
                v-else
                color="warning darken-2"
                right
                class="mr-2"
              >
                mdi-account-cancel
              </v-icon>
            </template>
            <template v-slot:[`item.password`]="{ item }">
              <v-icon
                v-clipboard:copy="item.password"
                v-clipboard:success="onCopy"
                style="cursor:pointer;"
                color="info darken-3"
                class="mr-2"
              >
                mdi-content-copy
              </v-icon>
            </template>
            <template v-slot:[`item.Alerta`]="{ item }">
              <v-tooltip
                v-if="item.active === 0"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    :color="'grey lighten-1'"
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-bell-off
                  </v-icon>
                </template>
                <span>La firma debe estar activa para configurar alertas</span>
              </v-tooltip>
              <v-icon
                v-else
                style="cursor:pointer;"
                :color="item.alert_active === 1 ? 'success darken-2' : 'grey lighten-1'"
                class="mr-2"
                @click="openAlertModal(item)"
              >
                {{ item.alert_active === 1 ? 'mdi-bell-ring' : 'mdi-bell-outline' }}
              </v-icon>
            </template>
          </v-data-table>
        </v-card-text>
      </base-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
import { environment } from '@/data/environment'

  export default {
    name: 'ShowFirmas',
    components: {
      AlertaFirmaModal: () => import('./AlertaFirmaModal'),
    },
    data () {
      return {
        show: false,
        searchTable: '',
        searchCompany: '',
        alertStatus: true,
        msgResponsePassword: '',
        password: '',
        progress: false,
        copyAlert: false,
        msgClaveCopiado: 'Clave Copiada',
        detailClients: [],
        selectedCompany: null,
        userInfo: null,
        showAlertModal: false,
        selectedFirma: {},
        loadingFirmas: false,
        showInfoAlert: true,
        headers: [
          { text: 'Cliente', value: 'company_name' },
          { text: 'Url Firma', value: 'url_location' },
          { text: 'Clave', value: 'password', align: 'center'  },
          { text: 'Vigencia Desde', value: 'valid_from' },
          { text: 'Vigencia Hasta', value: 'valid_until' },
          { text: 'Estado', value: 'active', align: 'center' },
          { text: 'Alerta', value: 'Alerta', align: 'center', sortable: false },
          { text: 'Fecha Creación   ', value: 'created_at' },
          { text: 'Fecha Actualización', value: 'updated_at' },
        ],
      }
    },
    computed: {
      ...mapState('firmas', [
        'listFirmas',
      ]),
      filteredClients() {
        const query = (this.searchCompany || '').toLowerCase()
        return this.detailClients.filter(c =>
          c.text.toLowerCase().includes(query)
        )
      },
      isGeneralAdmin() {
        return this.userInfo && (this.userInfo.rol === 'General-Admin' || this.userInfo.rol === 'General')
      },
    },
    created () {
      this.getUserInfo()
      this.obtenerCompanias()
      this.getListFirmas()
    },

    methods: {
      async getListFirmas () {
        this.loadingFirmas = true
        try {
          if (this.isGeneralAdmin) {
            await this.$store.dispatch('firmas/getListFirmas')
          } else if (this.selectedCompany) {
            await this.$store.dispatch('firmas/getListFirmas', this.selectedCompany)
          } else {
            await this.$store.dispatch('firmas/getListFirmas')
          }
        } finally {
          this.loadingFirmas = false
        }
      },
      filtrarFirmas() {
        this.getListFirmas()
      },
      getUserInfo() {
        try {
          const uid = localStorage.getItem('uid')
          if (uid) {
            this.userInfo = JSON.parse(atob(uid))
          }
        } catch (error) {
          console.error('Error al obtener información del usuario:', error)
        }
      },
      async obtenerCompanias() {
        if (this.isGeneralAdmin) {
          return
        }

        try {
          const response = await axios.get(environment.HIOPOSWEBSERVICES + '/getClientsForXML')

          let companies = response.data.Mensaje

          this.detailClients = companies.map(c => ({
            text: " [ " + c.id +  " ] " +  c.name,
            IdCompania: c.id,
          }))
        } catch (error) {
          console.error('Error al obtener compañías:', error)
        }
      },
      onCopy (e) {
        this.generateAlertCopy()
      },
      generateAlertCopy () {
        this.copyAlert = true
        setTimeout(() => {
          this.copyAlert = false
        }, 2000)
      },
      openAlertModal(firma) {
        this.selectedFirma = { ...firma }
        this.showAlertModal = true
      },
      closeAlertModal() {
        this.showAlertModal = false
        this.selectedFirma = {}
      },
      handleAlertUpdated() {
        this.getListFirmas()
      },
    },
  }
</script>

<style scoped>

</style>
